import React from "react";
// MDB Shims Imports
import Button from "../../Component/MDBShim/Button";
import DataTable from "../../Component/MDBShim/DataTable";
import Container from "../../Component/MDBShim/Container";
import Spinner from "../../Component/MDBShim/Spinner";
import toast from "../../Component/MDBShim/toast";
import MDBIcon from "../../Component/MDBShim/MDBIcon";

import PropTypes from "prop-types";
// import ReactTooltip from "react-tooltip";
import ReportsService from "../Security/ReportsService/reportsService";
import MainContext from "../../Context/MainContext/MainContext";
import { flushSync } from "react-dom";

export default class approvalReport extends React.Component {
    constructor(props) {
        super(props);

        let filters = this.determineFilters(props.filters);
        let topFilters = props.topFilters;

        //table headers & columns
        const approvals = {
            columns: [
                {
                    label: "Order #",
                    field: "orderId",
                    width: 150,
                },
                {
                    label: "Approval Date",
                    field: "approvalDate",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Setup Date",
                    field: "setupDate",
                    sort: "asc",
                    width: 180,
                },
                {
                    label: "Sales Location",
                    field: "salesLocation",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Service Location",
                    field: "serviceLocation",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Sales Rep",
                    field: "salesRep",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Patient",
                    field: "patient",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Zip Code",
                    field: "zipCode",
                    sort: "asc",
                    width: 150,
                },
                {
                    label: "Account",
                    field: "account",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Payor Source",
                    field: "payorSource",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Insurance",
                    field: "insurance",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Evaluation Type",
                    field: "evaluationType",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Category",
                    field: "category",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Product",
                    field: "product",
                    sort: "asc",
                    width: 150,
                },
                {
                    label: "Manufacturer",
                    field: "manufacturer",
                    sort: "asc",
                    width: 250,
                },
                {
                    label: "Points",
                    field: "points",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Amount",
                    field: "amount",
                    sort: "asc",
                    width: 200,
                },
                {
                    label: "Region",
                    field: "region",
                    sort: "asc",
                    width: 200,
                },
            ],
            rows: [],
        };

        this.state = {
            allApprovals: [],
            approvalData: approvals,
            startDate: new Date(filters.startDate),
            endDate: new Date(filters.endDate),
            pointsOnlyProducts: false,
            isLoaded: true,
            users: [],
            csvFunction: props.csvFunction,
            topFilters: topFilters,
        };
    }

    static contextType = MainContext; // For legacy class components

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Get the most up-to-date filters passed down from parent
        if (
            JSON.stringify(this.props.topFilters) !==
			JSON.stringify(this.state.topFilters)
        ) {
            this.setState({
                topFilters: this.props.topFilters,
            });
        }
        // Checks if the generate reports button has been clicked...JK
        if (prevProps.generateClicked !== this.props.generateClicked) {
            this.getApprovalReport();
        }
    }

    formatCurrency(amount) {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        }).format(amount);
    }

    determineFilters(userFilters) {
        let d = new Date(),
            filters = {};

        if (userFilters) {
            if (userFilters.startDate) {
                filters.startDate = new Date(userFilters.startDate);
            } else {
                filters.startDate = new Date(d.getFullYear(), d.getMonth(), 1);
            }

            if (userFilters.endDate) {
                filters.endDate = new Date(userFilters.endDate);
            } else {
                filters.endDate = d;
            }
        } else {
            filters.startDate = new Date(d.getFullYear(), d.getMonth(), 1);
            filters.endDate = d;
        }

        return filters;
    }

    getApprovalReport() {
        //const { currentUser, salesReps } = this.context;
        let st = this.state,
            tp = st.topFilters;
        let filters = {
            startDate: tp.startDate,
            endDate: tp.endDate,
        };

        try {
            filters = {
                startDate: new Date(tp.startDate).toLocaleDateString(),
                endDate: new Date(tp.endDate).toLocaleDateString(),
            };
        } catch {
            // toast.error("Please check your dates.");
            return;
        }

        // Have to check len since showDatePicker defaults to false at startup
        if (!tp.showDatePicker && tp.quickFilter.length > 0) {
            filters.startDate = tp.quickFilter[0].toLocaleDateString();
            filters.endDate = tp.quickFilter[1].toLocaleDateString();
        } else {
            // Check to make sure they have selected a date and the dates aren't set to the default if not using the quickfilter
            if (
                filters.startDate === "12/31/1969" ||
				filters.endDate === "12/31/1969"
            ) {
                // toast.error('Please check your dates');
                return;
            }
        }
        // Get users in the sales rep dropdown and add to the filter
        if (tp.salesRepsSelected && tp.salesRepsSelected.length > 0) {
            filters.ids = tp.salesRepsSelected || null;
        }
        //else if (
        //	currentUser.role === "ADMIN" ||
        //	currentUser.role === "EXECUTIVE_MANAGEMENT" ||
        //	currentUser.role === "FINANCE"
        //) {
        //	filters.ids = salesReps.map(x => x.id);
        //}

        this.setState({ isLoaded: false });

        ReportsService.getApprovalsReport(filters)
            .then((res) => {
                flushSync(() => { // PATCH
                    this.setState({ allApprovals: res });
                });

                this.formatRows();
            })
            .catch((err) => {
                //handle error..BC
            });
    }

    formatRows() {
        let approvals = this.state.allApprovals,
            dt = this.state.approvalData,
            ary = [];

        try {
            approvals.forEach((approval) => {
                ary.push({
                    orderId: approval.orderId,
                    approvalDate: approval.approvalDate || " ",
                    setupDate: approval.setupDate || " ",
                    salesLocation: approval.salesLocation,
                    serviceLocation: approval.serviceLocation,
                    salesRep: approval.salesRep
                        ? approval.salesRep.replace(/,/g, " ")
                        : "No Rep",
                    patient: approval.patient
                        ? approval.patient.replace(/,/g, " ")
                        : "No Patient",
                    zipCode: approval.zipCode
                        ? approval.zipCode.toString().replace(/,/g, " ")
                        : "No Zip Code",
                    account: approval.account
                        ? approval.account.replace(/,/g, " ")
                        : "No Account",
                    payorSource: approval.payorSource
                        ? approval.payorSource.replace(/,/g, " ")
                        : "No Payor Source",
                    insurance: approval.insurance
                        ? approval.insurance.replace(/,/g, " ")
                        : "No Insurance",
                    evaluationType: approval.evaluationType
                        ? approval.evaluationType.replace(/,/g, " ")
                        : "No Evaluation Type",
                    category: approval.category
                        ? approval.category.replace(/,/g, " ")
                        : "No Category",
                    product: approval.product
                        ? approval.product.replace(/,/g, " ")
                        : "No Product",
                    manufacturer: approval.vendor
                        ? approval.vendor.replace(/,/g, " ")
                        : "No Manufacturer",
                    points: approval.points ? parseFloat(approval.points) : 0,
                    amount: approval.amount ? parseFloat(approval.amount) : 0,
                    region: approval.region,
                });
            });
        } catch (e) {
            toast.error("An error occurred loading approvals.");
        }
        dt.rows = ary;

        this.setState({
            approvalData: dt,
            isLoaded: true,
        });
    }

    renderLoadingSpinner() {
        return (
            <Container className="mt-5">
                <div style={{ textAlign: "center", verticalAlign: "center" }}>
                    <Spinner multicolor />
                </div>
            </Container>
        );
    }

    //get the data in the table
    render() {
        if (this.state.isLoaded === false) {
            return this.renderLoadingSpinner();
        }
        return (
            <div>
                <DataTable
                    entriesOptions={[25, 50, 100]}
                    pagesAmount={10}
                    data={this.state.approvalData}
                    responsive
                    striped
                    bordered
                    search
                    paginated
                    sort
                ></DataTable>

                <Button
                    style={{ float: "right" }}
                    color={"blue"}
                    floating
                    size="sm"
                    data-tip={"Download rCSV"}
                    onClick={this.state.csvFunction.bind(
                        this,
                        this.state.approvalData,
                        "approvalExport.csv"
                    )}
                >
                    <MDBIcon icon="download" style={{ fontSize: "2em" }} />
                </Button>
                {/* <ReactTooltip /> */}
            </div>
        );
    }
}
